export const registrationSuccessPage = () =>
  import("./RegistrationSuccessPage").then((m) => ({
    Component: m.RegistrationSuccessPage,
  }));
